<div mat-dialog-title>
  Other apps for {{ (authenticationService.organisation$ | async)?.display_name }}
</div>
<div mat-dialog-content>
  <mat-action-list>
    <ng-container *ngFor="let option of (authenticationService.organisation$ | async).domains">
      <div class="mat-list-item" *ngIf="!['api', 'webapp'].includes(option.type.name)">
        <div class="list-item">
          <div>
            <a href="{{ getOptionUrl(option.url, option.type.name) }}" target="_blank">
              <span class="type">{{ option.type.display_name }}</span>
              <span class="url">{{ option.url }}</span>
            </a>
          </div>
          <a href="{{ getOptionUrl(option.url, option.type.name) }}" target="_blank">
            <mat-icon>open_in_new</mat-icon>
          </a>
        </div>
        <fury-loading-overlay [isLoading]="form.controls[option.type.name]?.controls?.isLoading?.value" [fill]="true"></fury-loading-overlay>
      </div>
    </ng-container>
  </mat-action-list>
</div>
<mat-dialog-actions>
  <button [mat-dialog-close]="false" color="accent" mat-flat-button>ANNULEREN</button>
</mat-dialog-actions>
